<div nz-flex [nzGap]="'small'" [nzVertical]="true">
  <div>
    <div class="header-wrapper">
      <h1>Lista użytkowników</h1>
      <button nz-button nzType="primary" [nzSize]="'default'" (click)="createUserClick()">
        <nz-icon nzType="plus-circle" nzTheme="outline" />
        Dodaj użytkownika
      </button>
    </div>

    <div nz-flex [nzGap]="'small'" [nzVertical]="false">
      <div>
        <button nz-button nz-dropdown [nzDropdownMenu]="menu">
          {{
            filters().isActive === null ? 'Wszyscy' : filters().isActive ? 'Aktywni' : 'Nieaktywni'
          }}
          <nz-icon nzType="down" />
        </button>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item (click)="filters.update((f) => ({ ...f, isActive: true }))">
              Aktywni
            </li>
            <li nz-menu-item (click)="filters.update((f) => ({ ...f, isActive: false }))">
              Nieaktywni
            </li>
            <li nz-menu-item (click)="filters.update((f) => ({ ...f, isActive: null }))">
              Wszyscy
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
      <input
        nz-input
        placeholder="Szukaj.."
        [ngModel]="filters().query"
        (ngModelChange)="queryChange($event)"
      />
    </div>
  </div>
  <div>
    <nz-table
      #basicTable
      class="users-table"
      [nzData]="searchResult()?.results!"
      [nzBordered]="true"
      [nzLoading]="loading()"
      [nzPageSize]="pageSize"
      [nzPageIndex]="pageIndex"
      [nzTotal]="total"
      [nzFrontPagination]="false"
      nzTableLayout="fixed"
      (nzQueryParams)="onQueryParamsChange($event)"
    >
      <thead>
        <tr>
          <th nzColumnKey="appUser.Id" [nzSortFn]="true" [nzSortOrder]="'descend'">Id</th>
          <th nzColumnKey="ssoLogin" [nzSortFn]="true">Login</th>
          <th nzColumnKey="firstName" [nzSortFn]="true">Imię</th>
          <th nzColumnKey="lastName" [nzSortFn]="true">Nazwisko</th>
          <th nzColumnKey="email" [nzSortFn]="true">Email</th>
          <th nzColumnKey="appRole.DefaultName" [nzSortFn]="true">Rola</th>
          <th nzColumnKey="unit.Name" [nzSortFn]="true">Bazowa placówka</th>
          <th nzColumnKey="appUser.isActive" [nzSortFn]="true">Aktywny</th>
          <th class="mhs-table-action-header">Akcja</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data">
          <td>{{ data.id }}</td>
          <td>{{ data.ssoLogin }}</td>
          <td>{{ data.firstName }}</td>
          <td>{{ data.lastName }}</td>
          <td>{{ data.email }}</td>
          <td>{{ data.roleName }}</td>
          <td>{{ data.defaultUnitName }}</td>
          <td>
            <div
              class="mhs-boolean-icon"
              [attr.aria-label]="data.isActive ? 'Aktywny' : 'Nieaktywny'"
              [title]="data.isActive ? 'Aktywny' : 'Nieaktywny'"
            >
              <nz-icon [nzType]="data.isActive ? 'check' : 'close'" />
            </div>
          </td>
          <td class="mhs-table-actions-cell">
            <div class="mhs-table-actions" nz-flex [nzGap]="'small'" [nzVertical]="false">
              <button nz-button nzType="primary" nzShape="circle" (click)="detailsClick(data.id!)">
                <nz-icon nzType="search" />
              </button>
              <a
                nz-dropdown
                [nzDropdownMenu]="userActionsMenu"
                nz-button
                nzType="default"
                nzShape="circle"
              >
                <nz-icon nzType="menu-fold" nzTheme="outline" />
              </a>
              <nz-dropdown-menu #userActionsMenu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item (click)="editUserClick(data.id!)">Edytuj</li>
                  <li nz-menu-item (click)="changePasswordClick(data.id!)">Zmień hasło</li>
                  @if (data.isActive) {
                    <li nz-menu-item (click)="deactivateUserClick(data.id!)">Dezaktywuj</li>
                  } @else {
                    <li nz-menu-item (click)="activateUserClick(data.id!)">Aktywuj</li>
                  }
                </ul>
              </nz-dropdown-menu>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
